import { FC } from 'react';
import styled from 'styled-components';

export const TabEnvList: FC = () => {
  const envList = [
    {
      name: 'NEXT_PUBLIC_BUILD_TS',
      value: process.env.NEXT_PUBLIC_BUILD_TS,
      descr: new Date(process.env.NEXT_PUBLIC_BUILD_TS ?? 0).toLocaleString(),
    },
    // { name: 'NEXT_PUBLIC_GIT_COMMIT', value: process.env.NEXT_PUBLIC_GIT_COMMIT },
    // { name: 'NEXT_PUBLIC_GIT_COMMIT_TS', value: process.env.NEXT_PUBLIC_GIT_COMMIT_TS },
    // { name: 'NEXT_PUBLIC_GIT_REF', value: process.env.NEXT_PUBLIC_GIT_REF },
    { name: '---', value: '' },
    { name: 'NEXT_PUBLIC_APP_MODE', value: process.env.NEXT_PUBLIC_APP_MODE },
    { name: 'NEXT_PUBLIC_SELF_URL_BASE', value: process.env.NEXT_PUBLIC_SELF_URL_BASE },
    { name: 'NEXT_PUBLIC_GRAPHQL_API_URL', value: process.env.NEXT_PUBLIC_GRAPHQL_API_URL },
    { name: 'NEXT_PUBLIC_APP_URL', value: process.env.NEXT_PUBLIC_APP_URL },
    { name: 'NEXT_PUBLIC_PA_URL', value: process.env.NEXT_PUBLIC_PA_URL },
    { name: 'NEXT_PUBLIC_GTW_URL', value: process.env.NEXT_PUBLIC_GTW_URL },
    { name: '---', value: '' },
    { name: 'NEXT_PUBLIC_DEBUG', value: process.env.NEXT_PUBLIC_DEBUG },
    {
      name: 'NEXT_PUBLIC_MERGED_GRAPHQL_REQUESTS_ENABLED',
      value: process.env.NEXT_PUBLIC_MERGED_GRAPHQL_REQUESTS_ENABLED,
    },
    {
      name: 'NEXT_PUBLIC_MERGED_GRAPHQL_REQUESTS_BATCH_MAX',
      value: process.env.NEXT_PUBLIC_MERGED_GRAPHQL_REQUESTS_BATCH_MAX,
    },
    {
      name: 'NEXT_PUBLIC_MERGED_GRAPHQL_REQUESTS_BATCH_INTERVAL',
      value: process.env.NEXT_PUBLIC_MERGED_GRAPHQL_REQUESTS_BATCH_INTERVAL,
    },
    { name: 'NEXT_PUBLIC_PERSIST_CACHE', value: process.env.NEXT_PUBLIC_PERSIST_CACHE },
    { name: '---', value: '' },
    {
      name: 'NEXT_PUBLIC_DEMO_HUB_SEED_PHRASE',
      value: process.env.NEXT_PUBLIC_DEMO_HUB_SEED_PHRASE,
    },
    {
      name: 'NEXT_PUBLIC_ENABLE_DOCUMENTS_OCR',
      value: process.env.NEXT_PUBLIC_ENABLE_DOCUMENTS_OCR,
    },
  ];

  return (
    <Container>
      {envList.map((iEnv, index) => (
        <Item key={index}>
          {iEnv.name}={iEnv.value}
          {iEnv.descr && <span style={{ opacity: 0.5 }}>{iEnv.descr}</span>}
        </Item>
      ))}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Item = styled.div`
  display: flex;
  gap: 8px;
`;
